export default {
  isActive: product => {
    product = product || {};
    const status = product.status;
    return (product.sold_date && status !== 'DOA' && !product.ceased_date) || (status === 'Trial');
  },
};
